export default __webpack_public_path__ + "static/media/cd409711559b435d.9309e3d4b6a23dcb0aafdfa2d852eea1.svg";